import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { StorageEnum } from '~/utils/enum/base';
import { useAppDispatch } from '~/utils/redux/hooks';
import { getProfile } from '~/thunks/auth/authThunk';
import { authActions } from '~/thunks/auth/authSlice';
import { Loading } from '~/components/common';

type Props = {
  redirectTo: string;
};

type ProfileStatus = 'loading' | 'ready' | 'error';

const PrivateRoute = (props: Props) => {
  const { redirectTo } = props;
  const dispatch = useAppDispatch();
  const accessToken = localStorage.getItem(StorageEnum.ACCESS_TOKEN);
  const [status, setStatus] = useState<ProfileStatus>('loading');

  useEffect(() => {
    if (!accessToken) return;

    dispatch(getProfile())
      .unwrap()
      .then(() => setStatus('ready'))
      .catch(() => {
        // Profile is required to render any admin page - an account the
        // backend can no longer confirm (expired/invalid token, deleted
        // account) must not be left looking logged in with stale data.
        dispatch(authActions.handleLogout());
        setStatus('error');
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken]);

  if (!accessToken || status === 'error') {
    return <Navigate to={redirectTo} replace />;
  }

  if (status === 'loading') {
    return <Loading />;
  }

  return <Outlet />;
};

export default PrivateRoute;
